import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface Organization {
  id: string;
  name: string;
  email?: string | null;
  supportEmail?: string;
  subdomain?: string;
  domains?: string[];
  roles?: string[];
  messageType?: string | null;
  message?: string | null;
}

export function useOrganizations() {
  return useQuery<Organization[]>({
    queryKey: ['organizations'],
    queryFn: () => api.get<Organization[]>('/organization'),
  });
}
